<div class="section-header">
    <div class="d-flex">
        <div class="w-100">
            <div class="container">
                <span *ngIf="tipoSezione == 1" class="h2">Cookie Policy</span>
                <span *ngIf="tipoSezione == 2" class="h2">Privacy Policy</span>
            </div>
        </div>
    </div>
</div>

<div class="wrapper">
    <div class="section-about-us">
        <div class="container" style="padding: 0 10vh 0 10vh;">
            <div class="py-4">
                <div class="d-flex">
                    <div class="w-100">
                        <!-- Cookies -->
                        <div *ngIf="tipoSezione==1" class="w-100">
                            <h2 class="titolo-1 border-bottom">Informativa</h2>
                            <div class="textBox">
                                Con riferimento al provvedimento “Individuazione delle modalità semplificate per
                                l'informativa e
                                l'acquisizione del consenso per l'uso dei cookie – 8 maggio 2014” (pubblicato sulla
                                Gazzetta
                                Ufficiale n. 126 del 3 giugno 2014), si descrivono in maniera specifica e analitica le
                                caratteristiche e le finalità dei cookie installati su questo sito indicando anche le
                                modalità
                                per selezionare/deselezionare i singoli cookie.
                                Il sito web https://centrofunzionale.regione.campania.it di proprietà della Regione
                                Campania
                                (in
                                seguito denominato solamente "Sito") utilizza i cookies per offrire i propri servizi
                                semplici e
                                efficienti agli Utenti durante la consultazione delle sue pagine.
                                Le tabelle riportate di seguito riepilogano i diversi tipi di cookie che potrebbero
                                essere
                                utilizzati sul Sito, insieme alla loro rispettiva funzione e durata (ovvero per quanto
                                tempo
                                ciascun cookie rimarrà sul vostro dispositivo).
                                L'informativa è valida solo per il suddetto Sito ed ai correlati suoi domini di secondo
                                e
                                terzo
                                livello e non per eventuali altri siti consultabili tramite link.
                                Facendo uso di questo Sito si acconsente il nostro utilizzo di cookie in conformità con
                                la
                                presente Cookie Policy.
                                Se non si acconsente al nostro utilizzo di cookie, occorre impostare il proprio browser
                                in
                                modo
                                appropriato oppure non usare il presente sito o gli eventuali domini di secondo e terzo
                                livello
                                corrispondenti. Se si decide di disabilitare i cookie che impieghiamo potrebbe essere
                                influenzata l'esperienza dell'utente mentre naviga sul nostro Sito.
                                Ulteriori informazioni sulla Privacy Policy sono consultabili in questa pagina più in
                                basso.
                            </div>
                            <h4>Avvertenza</h4>
                            <div class="textBox">
                                È declinata ogni responsabilità per qualsiasi eventuale danno derivante dall'uso diretto
                                o
                                dal
                                trattamento di dati o informazioni presenti e/o prelevati dal sito e non è garantito, in
                                alcun
                                modo, il funzionamento senza anomalie o interruzioni dall'uso improprio dei dati.
                                I dati pubblicati nella sezione “tempo reale” del sito sono acquisiti in tempo reale e,
                                pertanto, sono da considerarsi intrinsecamente ''grezzi'', in quanto non ancora
                                sottoposti
                                al
                                processo di validazione, che ne certifica formalmente l'ufficialità. Anche le
                                elaborazioni
                                grafiche sono derivate automaticamente dai dati acquisiti e senza alcun controllo o
                                validazione
                                umana.
                                Il Centro Funzionale della Regione Campania non assume alcuna responsabilità per danni o
                                problemi derivanti dal loro utilizzo improprio, restando l'utente unico responsabile
                                dell'uso
                                dei dati e di qualsiasi elaborazione, trasformazione e trattamento degli stessi.
                                Il Centro Funzionale della Regione Campania resta anche sollevato da qualsiasi
                                responsabilità
                                relativa a prodotti ottenuti dall'elaborazione o rappresentazione dei dati originari,
                                prelevati
                                dal sito che possono essere utilizzati, in tutto o in parte, senza il preventivo
                                consenso
                                del
                                Centro Funzionale Decentrato, esclusivamente per finalità di uso personale, studio,
                                ricerca
                                o
                                comunque non commerciali e, comunque, con citazione della fonte e impegno dell'utente a
                                trasmettere al Centro Funzionale Decentrato copia di ogni studio o pubblicazione
                                connessa
                                e/o
                                derivante dall'utilizzo dei dati forniti.
                                Si specifica che le stazioni di monitoraggio presenti sul sito, di proprietà del Centro
                                Funzionale Decentrato della Regione Campania, sono sottoposte a interventi di
                                manutenzione
                                preventiva (programmata) e straordinaria (non prevedibile), che potrebbero rendere
                                indisponibili
                                i dati usualmente rilevati.
                            </div>
                            <h2 class="titolo-1 border-bottom">Informazioni generali sui cookies</h2>
                            <h4>Cosa sono i cookies?</h4>
                            <div class="textBox">
                                I cookie sono file informatici o dati parziali che possono venire salvati sul vostro
                                computer (o
                                altri dispositivi abilitati alla navigazione su internet, per esempio smartphone o
                                tablet)
                                quando visitate un Sito. Di solito un cookie contiene il nome del sito internet dal
                                quale il
                                cookie stesso proviene, la "durata vitale" del cookie (ovvero per quanto tempo rimarrà
                                sul
                                vostro dispositivo), ed un valore, che di regola è un numero unico generato in modo
                                casuale.
                            </div>
                            <h4>Per cosa si usano i cookies?</h4>
                            <div class="textBox">
                                Si utilizzano i cookie per rendere la navigazione più semplice e per meglio adattarli ai
                                vostri
                                interessi e bisogni. I cookie possono anche venire usati per aiutare a velocizzare le
                                vostre
                                future esperienze ed attività sui siti web. Inoltre si usano i cookie per compilare
                                statistiche
                                anonime aggregate che consentono di capire come le persone usano i siti in modo da
                                aiutare a
                                migliorare la struttura ed i contenuti di questi siti.
                            </div>
                            <h4>Tipologie di Cookie</h4>
                            <div class="textBox">
                                <strong>Necessario: </strong>sono essenziali per il corretto funzionamento dei siti,
                                consentono
                                alle persone di navigare sui siti internet e di sfruttarne le caratteristiche come la
                                memorizzazione di azioni precedenti (testi inseriti) quando si ritorna ad una pagina nel
                                corso
                                della medesima sessione. Questi cookie non ti identificano come individuo.
                                Se non si accettano questi cookie, la resa del sito internet, o sezioni dello stesso,
                                potrebbe
                                risultare impattate.

                                <br><strong>Performance: </strong>aiutano a capire come gli utenti interagiscono con i
                                siti
                                internet fornendo informazioni relative alle sezioni visitate, il tempo trascorso sul
                                sito,
                                e
                                qualsiasi questione che sia emersa, per esempio un messaggio di errore. Questo aiuta a
                                migliorare la resa dei siti internet. Questi cookie non ti identificano come individuo.
                                Tutti i
                                dati vengono raccolti e aggregati in forma anonima.

                                <br><strong>Funzionalità: </strong>permettono ai siti internet di ricordare le scelte
                                che si
                                fanno (per esempio, il vostro nome utente, la lingua prescelta o la regione in cui vi
                                trovate,
                                gli eventuali prodotti inseriti nel carrello della spesa) per fornirvi un'esperienza
                                online
                                più
                                personalizzata. Possono anche consentire agli utenti di visualizzare i video, entrare
                                nei
                                giochi
                                e interagire con gli strumenti sociali tipo blog, chatroom e forum. Le informazioni che
                                vengono
                                raccolte da questi cookie possono includere informazioni personali identificabili che
                                avete
                                fornito, per esempio il vostro nome utente o immagine del profilo. Se non si accettano
                                questi
                                cookie, la resa e funzionalità del sito internet potrebbe risultare impattate e
                                l'accesso ai
                                contenuti del sito potrebbe venire limitata.

                                <br><strong>Targeting / pubblicità: </strong>vengono usati per presentare contenuti più
                                adatti a
                                voi e ai vostri interessi. Possono venire usati per visualizzare pubblicità mirate o per
                                limitare il numero di volte che visualizzate una pubblicità. Inoltre aiutano a misurare
                                l'efficacia delle campagne pubblicitarie sui siti internet. Si possono usare questi
                                cookie
                                per
                                ricordare i siti internet che avete visitato e potrebbero 1condividere queste
                                informazioni
                                con
                                terze parti. La maggioranza di cookie di questo tipo tracciano i consumatori attraverso
                                il
                                loro
                                indirizzo IP e quindi potrebbero raccogliere alcune informazioni personali
                                identificabili.
                            </div>
                            <h4>Che tipi di cookies si usano? </h4>
                            <div class="textBox">
                                Due tipi di cookie possono venire usati sui siti: 'session cookies' e 'persistent
                                cookies'.
                                <ul>
                                    <li><strong>session cookies</strong>: sono cookie temporanei che rimangono sul
                                        vostro
                                        dispositivo fino al momento in cui lasciate il sito.</li>
                                    <li><strong>persistent cookies</strong>: sono cookie che rimangono sul vostro
                                        dispositivo
                                        per molto più tempo o fino a quando lo cancellate manualmente (quanto tempo il
                                        cookie
                                        rimane sul vostro dispositivo dipenderà dalla ‘durata vitale' del cookie in
                                        oggetto
                                        e
                                        dalle impostazioni del vostro browser).</li>
                                </ul>
                                Alcune delle pagine che visitate possono anche raccogliere informazioni mediante ‘pixel
                                tags'
                                (conosciuti anche con il nome ‘clear gifs') che potrebbero venire condivisi con terze
                                parti
                                che
                                assistono in modo diretto le attività promozionali e lo sviluppo dei siti internet. Per
                                esempio,
                                informazioni sull'uso dei siti internet relative alle persone che visitano i siti
                                possono
                                venire
                                condivise con agenzie pubblicitarie per mirare i banner pubblicitari sui siti internet
                                in
                                modo
                                ottimale.

                                Un'altra suddivisione di tipologia di Cookie - indicata dal Garante per la protezione
                                dei
                                dati
                                personali - è tra <strong>Cookies Tecnici, Cookies di Profilazione, Cookies di prima
                                    parte,
                                    Cookies di terza parte</strong>.
                                <br><br>
                                <ul>
                                    <li><strong><em>Cookies Tecnici</em></strong>: servono a effettuare la navigazione o
                                        a
                                        fornire un servizio richiesto dall'utente. Non vengono utilizzati per scopi
                                        ulteriori e
                                        sono normalmente installati direttamente dal titolare del sito web. Senza il
                                        ricorso
                                        a
                                        tali cookie, alcune operazioni non potrebbero essere compiute o sarebbero più
                                        complesse
                                        e/o meno sicure, come ad esempio le attività di home banking (visualizzazione
                                        dell'estratto conto, bonifici, pagamento di bollette, ecc.), per le quali i
                                        cookie,
                                        che
                                        consentono di effettuare e mantenere l'identificazione dell'utente nell'ambito
                                        della
                                        sessione, risultano indispensabili.</li>
                                    <li><strong><em>Cookies di Profilazione</em></strong>: utilizzati per tracciare la
                                        navigazione dell'utente in rete e creare profili sui suoi gusti, abitudini,
                                        scelte,
                                        ecc.
                                        Con questi cookie possono essere trasmessi al terminale dell'utente messaggi
                                        pubblicitari in linea con le preferenze già manifestate dallo stesso utente
                                        nella
                                        navigazione online.</li>
                                    <li><strong><em>Cookies di prima parte (first-part cookie)</em></strong>: generati e
                                        gestiti
                                        direttamente dal soggetto gestore del sito web sul quale l'utente sta navigando.
                                    </li>
                                    <li><strong><em>Cookies di terza parte (third-part cookie)</em></strong>: generati e
                                        gestiti
                                        da soggetti diversi dal gestore del sito web sul quale l'utente sta navigando
                                        (in
                                        forza,
                                        di regola, di un contratto tra il titolare del sito web e la terza parte)</li>
                                </ul>


                                <h4>Cosa sono i cookies di terze parti? </h4>Svariati fornitori possono impostare cookie
                                sul
                                vostro dispositivo quando visitate i siti per consentirgli di erogare i servizi che
                                stanno
                                fornendo. Se desiderate avere ulteriori informazioni relative a questi cookie, insieme a
                                informazioni su come evitare la ricezione di questi cookie potete consultare la tabella
                                apposita
                                sul sito <a
                                    href="http://www.youronlinechoices.com/it/">http://www.youronlinechoices.com/it/</a>.
                            </div>
                            <h4>Come posso controllare o cancellare i cookies? </h4>
                            <div class="textBox">
                                La maggioranza dei browser internet sono inizialmente impostati per accettare i cookie
                                in
                                modo
                                automatico. Potete modificare queste impostazioni per bloccare i cookie o per avvertirvi
                                che
                                dei
                                cookie vengono mandati al vostro dispositivo. Esistono svariati modi per gestire i
                                cookie,
                                si
                                può fare riferimento al manuale d'istruzioni o alla schermata di aiuto del vostro
                                browser
                                per
                                scoprire come regolare o modificare le impostazioni del vostro browser. Disabilitando i
                                cookie
                                potrebbero venire influenzata la vostra navigazione, per esempio potreste non essere in
                                grado di
                                visitare certe sezioni o non ricevere informazioni personalizzate quando visitate un
                                sito.

                                Se usate dispositivi diversi tra loro per visualizzare e accedere ai siti Internet (per
                                esempio,
                                computer, smartphone, tablet, ecc.), dovrete assicurarvi che ciascun browser su ciascun
                                dispositivo sia regolato per riflettere le vostre preferenze relative ai cookie.<br>
                            </div>
                            <h4>Questo Sito utilizza cookie "tecnici" per:</h4>
                            <div class="textBox">
                                <ul>
                                    <li>la personalizzazione dell'interfaccia utente (es. per registrare le preferenze
                                        espresse
                                        dall'utente quali il formato di visualizzazione della pagina, etc.);</li>
                                    <li>una migliore fruibilità del sito e dei suoi contenuti audio-visivi (es. tramite
                                        l'esecuzione di programmi di tipo flash player);</li>
                                    <li>il corretto funzionamento della connessione (es. indirizzando tra più server in
                                        modo
                                        appropriato le richieste dell'utente).</li>
                                </ul>
                            </div>
                            <h4>Questo Sito utilizza cookie di terze parti per i quali non ne gestisce l'operatività
                            </h4>
                            <div class="textBox">
                                (non ha pertanto il controllo ed accesso alle informazioni fornite/acquisite) in quanto
                                il
                                loro
                                funzionamento è nella responsabilità delle terze parti. Per questi cookie è possibile
                                accedere
                                all'informativa ed ai moduli di acquisizione del consenso delle terze parti, cliccando
                                sui
                                link
                                sotto riportati. Le terze parti sono:
                                <ol>
                                    <li>Operatori pubblicitari e di e-commerce, che gestiscono cookie tipicamente per
                                        tener
                                        traccia delle attività che l'utente ha effettuato su questo Sito (provenendo
                                        anche
                                        da
                                        altri siti internet), al fine di personalizzazione i messaggi promozionali sui
                                        potenziali interessi dell'utente sui siti dei propri affiliati. Tali soggetti
                                        sono:
                                        Facebook Inc.: <a
                                            href="https://mail.regione.campania.it/owa/redir.aspx?SURL=rSP1huTKUqksiD5xeJguVWNW5jLXAIoAF6G2BkOGq4R6_LDiYnzSCGgAdAB0AHAAcwA6AC8ALwB3AHcAdwAuAGYAYQBjAGUAYgBvAG8AawAuAGMAbwBtAC8AcABvAGwAaQBjAHkALgBwAGgAcAA.&amp;URL=https%3A%2F%2Fwww.facebook.com%2Fpolicy.php">https://www.facebook.com/policy.php</a>
                                    </li>
                                    <li>Soggetti dei cui servizi il Centro Funzionale della Campania si avvale per
                                        raccogliere
                                        informazioni aggregate/statistiche sugli utenti che visitano questo Sito. E'
                                        infatti
                                        utilizzato il servizio: Google Analytics; fornito dalla società Google Inc.: <a
                                            href="https://mail.regione.campania.it/owa/redir.aspx?SURL=YxMJ-x1OLbQzPXH27igWDEo5e_FtuJW4W3B-3feaLEJ6_LDiYnzSCGgAdAB0AHAAOgAvAC8AdwB3AHcALgBnAG8AbwBnAGwAZQAuAGMAbwBtAC8AaQBuAHQAbAAvAGUAbgAvAHAAbwBsAGkAYwBpAGUAcwAvAHAAcgBpAHYAYQBjAHkALwA.&amp;URL=http%3A%2F%2Fwww.google.com%2Fintl%2Fen%2Fpolicies%2Fprivacy%2F">http://www.google.com/intl/en/policies/privacy/</a>
                                    </li>
                                </ol>
                            </div>
                            <h2 class="titolo-1 border-bottom">Gestione generale cookies</h2>
                            <h4>Come disabilitare i cookie mediante configurazione del browser</h4>
                            <div class="textBox">
                                <ul>
                                    <li>Disabilitazione dei cookie su <a
                                            href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie">Firefox
                                        </a></li>
                                    <li>Disabilitazione dei cookie su <a
                                            href="http://www.google.com/policies/technologies/managing/">Chrome</a></li>
                                    <li>Disabilitazione dei cookie su <a
                                            href="http://windows.microsoft.com/it-it/internet-explorer/delete-manage-cookies#ie=ie-11">Internet
                                            Explorer</a></li>
                                    <li>Disabilitazione dei cookie su <a
                                            href="http://support.apple.com/kb/HT1677?viewlocale=it_IT&amp;locale=it_IT">Safari
                                        </a></li>
                                    <li>Disabilitazione dei cookie su <a
                                            href="http://help.opera.com/Mac/12.10/it/cookies.html">Opera</a></li>
                                </ul>
                            </div>
                            <h4>Come disabilitare i cookie di specifici servizi di terzi</h4>
                            <div class="textBox">
                                <ul>
                                    <li><a href="http://www.google.com/ads/preferences/?hl=it">Servizi di Google</a>
                                    </li>
                                    <li><a href="https://www.facebook.com/help/cookies?ref_type=sitefooter">Facebook</a>
                                    </li>
                                </ul>
                            </div>
                            <h4>Eliminazione dei Cookie Flash</h4>
                            <div class="textBox">
                                <ul>
                                    <li><a
                                            href="http://www.macromedia.com/support/documentation/en/flashplayer/help/settings_manager07.html">Flash
                                            Player</a></li>
                                </ul>
                            </div>
                            <div class="textBox">
                                Questa pagina è visibile, mediante link da tutte le pagine del Sito ai sensi dell'art.
                                122
                                secondo comma del D.lgs. 196/2003 e a seguito delle modalità semplificate per
                                l'informativa
                                e
                                l'acquisizione del consenso per l'uso dei cookie pubblicata sulla Gazzetta Ufficiale
                                n.126
                                del 3
                                giugno 2014 e relativo registro dei provvedimenti n.229 dell'8 maggio 2014.
                            </div>
                        </div>
                        <!-- Privacy -->
                        <div *ngIf="tipoSezione == 2" class="w-100">
                            <h2 class="titolo-1 border-bottom" id="privacy">Informativa sulla privacy</h2>
                            <h4>Il significato di questa comunicazione</h4>
                            <div class="textBox">
                                In questa pagina sono descritte le modalità di gestione del portale Centro
                                Funzionale&nbsp;
                                in
                                riferimento al trattamento dei dati personali degli utenti che lo consultano.
                                Si tratta di un'informativa che è resa ai sensi dell'art. 13 del <a
                                    href="http://www.camera.it/parlam/leggi/deleghe/Testi/03196dl.htm">D.lgs. n.
                                    196/2003</a>
                                (Codice in materia di protezione dei dati personali) a coloro che interagiscono con i
                                servizi
                                web del Portale per la protezione dei dati personali, accessibili per via telematica a
                                partire
                                dall'indirizzo: <a
                                    href="https://centrofunzionale.regione.campania.it/">centrofunzionale.regione.campania.it</a>
                                corrispondente alla pagina iniziale del Portale del Centro Funzionale della Regione
                                Campania.
                                L'informativa è resa solo per il Portale del Centro Funzionale della Regione Campania e
                                non
                                anche per altri siti web eventualmente consultati dall'utente tramite link.
                            </div>
                            <h4>Il 'titolare' del trattamento dei dati</h4>
                            <div class="textBox">
                                A seguito della consultazione di questo sito possono essere trattati dati relativi a
                                persone
                                identificate o identificabili.
                                Il “titolare” del loro trattamento è l'Ente “<strong>Centro Funzionale</strong>
                                <strong>Regione
                                    Campania</strong>” con <strong>sede al Centro Direzionale di Napoli, Isola C/3,
                                    80143,
                                    Napoli (Italia)</strong>.
                            </div>

                            <h4>La raccolta dei dati</h4>
                            <div class="textBox">
                                Il sito è stato concepito con la prevalente funzione di fornire dati e informazioni del
                                Centro
                                Funzionale della Regione Campania. In linea generale, quindi, il sito non raccoglie dati
                                personali. Quando si presenta la necessità di raccogliere dati personali – che l'utente
                                è
                                sempre
                                libero di non fornire – viene contestualmente evidenziata un'apposita informativa
                                redatta
                                secondo la legge italiana e comunitaria che sottolinea, tra l'altro, le specifiche
                                finalità
                                d'uso dei dati raccolti.
                                Raccomandiamo di leggere queste comunicazioni prima di fornire i propri dati.
                            </div>
                            <h4>Il luogo di trattamento dei dati</h4>
                            <div class="textBox">
                                I trattamenti connessi ai servizi web di questo sito hanno luogo presso il Centro
                                Funzionale
                                della Regione Campania, con sede in Napoli al Centro Direzionale di Napoli, Isola C/3,
                                80143,
                                Napoli, che provvede alla gestione del server dove fisicamente risiedono i dati.
                                I dati personali sono curati solo da personale tecnico dell'Ente, appositamente
                                incaricato
                                del
                                trattamento, oppure da eventuali incaricati di occasionali operazioni di manutenzione.
                                Nessun dato derivante dal servizio web viene comunicato o diffuso.
                                I dati personali forniti dagli utenti che inoltrano richieste di invio di materiale
                                informativo
                                (bollettini, Cd-rom, newsletter, relazioni annuali, risposte a quesiti, atti e
                                provvedimenti,
                                ecc.) sono utilizzati al solo fine di eseguire il servizio o la prestazione richiesta e
                                sono
                                comunicati a terzi nel solo caso in cui ciò sia a tal fine necessario.
                            </div>
                            <h4>I diritti degli interessati</h4>
                            <div class="textBox">
                                I soggetti cui si riferiscono i dati personali hanno il diritto in qualunque momento di
                                ottenere
                                la conferma dell'esistenza o meno dei medesimi dati e di conoscerne il contenuto e
                                l'origine,
                                verificarne l'esattezza o chiederne l'integrazione o l'aggiornamento, oppure la
                                rettificazione
                                (<a href="http://www.camera.it/parlam/leggi/deleghe/Testi/03196dl.htm">art. 7 del d.lgs.
                                    n.
                                    196/2003</a>).
                                Ai sensi del medesimo articolo gli utenti interessati hanno il diritto di chiedere la
                                cancellazione, la trasformazione in forma anonima o il blocco dei dati trattati in
                                violazione di
                                legge, nonché di opporsi in ogni caso, per motivi legittimi, al loro trattamento.
                                Le richieste vanno rivolte all'indirizzo e-mail:
                                <u>salvatore.gentile&#64;regione.campania.it</u>.
                            </div>
                            <h2 class="titolo-1 border-bottom">La tipologia dei dati trattati</h2>

                            <h4>Dati di navigazione</h4>
                            <div class="textBox">
                                I sistemi informatici e le procedure software preposte al funzionamento di questo sito
                                web
                                acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui
                                trasmissione è
                                implicita nell'uso dei protocolli di comunicazione di Internet.
                                Si tratta di informazioni che non sono raccolte per essere associate a interessati
                                identificati,
                                ma che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con
                                dati
                                detenuti da terzi, permettere di identificare gli utenti.
                                In questa categoria di dati rientrano gli indirizzi IP o i nomi a dominio dei computer
                                utilizzati dagli utenti che si connettono al sito, gli indirizzi in notazione URI
                                (Uniform
                                Resource Identifier) delle risorse richieste, l'orario della richiesta, il metodo
                                utilizzato
                                nel
                                sottoporre la richiesta al server, la dimensione del file ottenuto in risposta, il
                                codice
                                numerico indicante lo stato della risposta data dal server (buon fine, errore, ecc.) ed
                                altri
                                parametri relativi al sistema operativo e all'ambiente informatico dell'utente.
                                Questi dati vengono utilizzati al solo fine di ricavare informazioni statistiche anonime
                                sull'uso del sito e per controllarne il corretto funzionamento e vengono mantenuti per
                                il
                                periodo minimo richiesto dalla normativa vigente.
                                I dati potrebbero essere utilizzati per l'accertamento di responsabilità in caso di
                                ipotetici
                                reati informatici ai danni del sito.
                            </div>
                            <h4>Dati forniti volontariamente dall'utente </h4>
                            <div class="textBox">
                                I sistemi informatici e le procedure software preposte al funzionamento di questo sito
                                web
                                acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui
                                trasmissione è
                                implicita nell'uso dei protocolli di comunicazione di Internet.
                                Specifiche informative di sintesi verranno progressivamente riportate o visualizzate
                                nelle
                                pagine del sito predisposte per particolari servizi a richiesta.
                            </div>

                            <h4>Le modalità del trattamento</h4>
                            <div class="textBox">
                                I dati personali sono trattati con strumenti automatizzati per il tempo strettamente
                                necessario
                                a conseguire gli scopi per cui sono stati raccolti.
                                Sono osservate specifiche misure di sicurezza per prevenire la perdita dei dati, usi
                                illeciti o
                                non corretti ed accessi non autorizzati.
                            </div>
                            <h4>La facoltatività del conferimento dei dati</h4>
                            <div class="textBox">
                                A parte quanto specificato per i dati di navigazione, l'utente è libero di fornire i
                                dati
                                personali riportati nei moduli di richiesta o comunque indicati in contatti con
                                l'Ufficio
                                per
                                sollecitare l'invio di materiale informativo o di altre comunicazioni.
                                Il loro mancato conferimento può comportare l'impossibilità di ottenere quanto
                                richiesto.
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>